export class WorkOrderManageTaskParametersDto {
    taskIdsToLink: Array<number>;
    taskIdsToUnLink: Array<number>;
    communityId: number;
    workOrderId: number;
}
